import{jsxs as r,Fragment as t,jsx as e}from"react/jsx-runtime";import{useRef as o}from"react";import i from"react-tooltip";import n from"styled-components";const c=n(i)`
  // Trick to push higher specificity
  && {
    background: #0a273d;
    color: #ffffff;
    padding: 6px;
    font-weight: 400;
    font-size: 12px;
    border: none;
    border-radius: 2px;
  }
`,d=({children:i,text:n,...d})=>{const f=o((new Date).getTime().toString()).current;return r(t,{children:[e("span",{"data-tip":!0,"data-for":f,children:i}),e(c,{id:f,...d,effect:"solid",children:n})]})};export{d as Tooltip};
//# sourceMappingURL=Tooltip.js.map
